import { createContext, useContext } from 'react';
import { ProductFilters, RequestCategory, RequestReadState } from '@atlassian/notification-types/types';
export var NotificationsStoreContext = /*#__PURE__*/createContext({
  analyticsContext: {
    product: 'unset',
    requestCategory: RequestCategory.DIRECT,
    readStateFilter: RequestReadState.ANY,
    productFilter: ProductFilters.ANY,
    screenName: '',
    view: 'list'
  },
  intlLocale: {
    current: 'en-US'
  },
  packageName: '@atlassian/notification-common',
  packageVersion: 'v9.9.9',
  updateIntlLocale: function updateIntlLocale() {},
  userId: undefined
});
export var useOriginId = function useOriginId() {
  var notificationsContext = useContext(NotificationsStoreContext);
  return notificationsContext.analyticsContext.originId;
};